/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model'];
const factory = function (Model) {
  class BalanceChecker extends Model {
    static initClass() {
      this.prototype.id = null;
      this.prototype.$resource = 'balanceChecker';
    }

    $serialize(data) {
      const newData = angular.copy(data);
      const balanceDate = data.balanceDate.split('-');
      newData.year = Number(balanceDate[0]);
      newData.month = Number(balanceDate[1]);
      return newData;
    }

    getStatus() {
      if (this.balanceMatchType === 'FULLY_CHECKED') {
        return 'fully-checked';
      }
      if (this.balance === this.calculatedBalance) {
        return 'matched';
      }
      if (this.balanceMatchType === 'DURING') {
        return 'matched-during';
      }
      return 'unmatched';
    }
  }
  BalanceChecker.initClass();

  return BalanceChecker;
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.balanceChecker', moduleDeps)
  .factory('BalanceChecker', factory);
